module.exports = __webpack_public_path__ + "img/Cameroon.377f22f3.svg";